<template>
    <div class="paper_upload_div">
        <form @submit.prevent="searchPaperBeforeSubmitMethod">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Search research papers across the web by title, keywords, or topic</label>
                        <div class="search_paper">
                            <input type="text" class="form-control" v-validate="'required'" v-model="search_term"
                                name="search_term" v-bind:class="{ 'is-invalid': errors.has('search_term') }"
                                data-vv-as="search query" autocomplete="off">
                            <small class="invalid-feedback" v-if="errors.has('search_term')">{{
                                errors.first('search_term') }}</small>
                            <i class="fa fa-search" aria-hidden="true" @click="searchPaperBeforeSubmitMethod"
                                :class="search_term.length > 0 ? 'active' : ''"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div id="vac-circle" v-if="loader" class="mt-3 mb-3"></div>
            <div class="search_papers_list" v-if="searchResultPaperData">
                <div class="search_paper_list_items" v-for="(item, index) in searchResultPapers" :key="index">
                    <div class="search_paper_item">
                        <h2 class="search_paper_title">
                            <a :href="item.url" target="_blank">{{ item.title }}</a>
                        </h2>
                        <h5 class="paper_author_name">{{ item.authors }}</h5>
                        <span class="btn btn-primary" @click="updatePpDetailMethod(item)"><i
                                class="fa fa-bookmark-o mr-1" aria-hidden="true"></i> Save</span>
                    </div>
                </div>
            </div>
        </form>
        <!-- Update PP Details -->
        <update-pp-details v-if="savePaperPopupState" :paperInfo="paperUpdateInfo"></update-pp-details>
    </div>
</template>

<script>
/*eslint-disable */

import axios from 'axios';
import { bus } from '@/main';
import root from '@/_helpers/roots';
import updatePpDetails from '../../save-paper-info';

let paperUploadFromQuery = root.uploadPDFFromQueryApiUrl.link;

export default {
    name: 'add-paper-from-query',
    components: {
        'update-pp-details': updatePpDetails
    },
    props: [],
    data() {
        return {
            submitted: false,
            search_term: '',
            savePaperPopupState: false,
            paperUpdateInfo: null,
            searchResultPaperData: null,
            searchResultPapers: [],
            loader: false
        }
    },
    computed: {

    },
    mounted() {
        bus.$on('savePaperPopupStateBus', (data) => {
            this.savePaperPopupState = data;
        });
    },
    methods: {
        updatePpDetailMethod(data) {
            this.paperUpdateInfo = data
            this.savePaperPopupState = true
            document.body.classList.add('body_right_scroll_remove')
        },
        getPaperPileListAgain() {
            this.$store.dispatch('getAllPaperPileFun')
        },
        searchPaperBeforeSubmitMethod() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.searchResultPaperData = null
                    this.searchResultPapers = []
                    this.loader = true
                    axios.get(paperUploadFromQuery + '?query=' + this.search_term).then((res) => {
                        this.searchResultPaperData = res.data.data
                        this.searchResultPapers = this.searchResultPaperData.result
                        this.loader = false
                    }).catch((err) => {
                        this.loader = false
                    })
                    return;
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.paper_upload_div {
    label {
        font-size: 18px;
        margin-bottom: 4px;
    }

    .form-control {
        width: 100%;
        font-weight: normal;
        font-size: 18px;
        border-radius: 10px;
        height: 48px;
        padding: 10px 20px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        outline: none !important;
        box-shadow: none !important;
        color: #ffd400;
        background: rgba(255, 255, 255, 0.03);

        &:focus {
            border-color: #ffd400;
        }

        &:focus~.fa-search {
            color: #ffd400;
        }
    }

    .invalid-feedback {
        font-size: 14px;
        line-height: 1;
    }

    .btn-primary {
        cursor: pointer;
        position: relative;
        min-width: 65px;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        outline: none !important;
        background: rgba(255, 255, 255, 0.12) !important;
        color: #ffd400 !important;
        border: none;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 16px;
        line-height: 1;
        padding: 6px 0px;

        &:hover {
            background: #87cefa !important;
            color: #22292f !important;
        }
    }

    .incorrected_error_txt {
        color: #dc3545;
        font-size: 16px;
    }

    .search_paper {
        position: relative;

        .fa-search {
            position: absolute;
            top: 14px;
            right: 20px;
            font-size: 18px;
            cursor: pointer;

            &.active {
                color: #ffd400;

                &:hover {
                    color: #87cefa;
                }
            }
        }

        .form-control {
            padding-right: 35px;
        }
    }

    .search_papers_list {
        .search_paper_list_items {
            margin-bottom: 15px;

            &:last-child {
                margin-bottom: 0px;
            }
        }

        .search_paper_title {
            font-size: 18px;
            margin-bottom: 2px;
            line-height: 1.3;

            a {
                color: #87cefa;
                text-decoration: none;

                &:hover {
                    color: #ffd400;
                }
            }
        }

        .paper_author_name {
            font-size: 15px;
            font-family: 'georgiaregular';
            color: #d6d6d6;
            line-height: 1.3;
            margin-bottom: 5px;
        }
    }

    @-webkit-keyframes vac-spin {
        from {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        to {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }

    @keyframes vac-spin {
        from {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }

        to {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }

    #vac-circle {
        margin: auto;
        height: 28px;
        width: 28px;
        border: 3px rgba(0, 0, 0, 0.25) solid;
        border-top: 3px #c0bebe solid;
        border-right: 3px #c0bebe solid;
        border-bottom: 3px #c0bebe solid;
        border-radius: 50%;
        -webkit-animation: vac-spin 1s infinite linear;
        -moz-animation: vac-spin 1s infinite linear;
        animation: vac-spin 1s infinite linear;
    }
}
</style>